import React from 'react';
import Highcharts from './utils/highcharts';
import bar from './custom/bar';
import column from './custom/column';
import defaultChart from './chart';
import donut from './custom/donut';
import geospatialbubblemap from './custom/geospatial_bubble_map';
import line from './custom/line';
import lineargauge from './custom/linear_gauge';
import stackedbar from './custom/stacked_bar';
import stackedcolumn from './custom/stacked_column';
import treemap from './custom/tree_map';
var highchartsInterface = () => ({
  create(options, ref, theme) {
    var chartType = options.chart.type;
    var chartComponents = {
      bar,
      column,
      defaultChart,
      donut,
      geospatialbubblemap,
      line,
      lineargauge,
      stackedbar,
      stackedcolumn,
      treemap
    };
    var Element = chartComponents[chartType] || chartComponents.defaultChart;
    return /*#__PURE__*/React.createElement(Element, {
      options: options,
      ref: ref,
      theme: theme
    });
  },
  lib: Highcharts
});
export * from './components';
export { highchartsInterface };
export default highchartsInterface;